import { localDateKey } from './localDate';

export function storyPeriod(date, view) {
  const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  let end;
  if (view === 'month') {
    start.setDate(1);
    end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
  } else {
    start.setDate(start.getDate() - (start.getDay() + 6) % 7);
    end = new Date(start);
    end.setDate(start.getDate() + 6);
  }
  const format = d => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  return { start: localDateKey(start), end: localDateKey(end), title: view === 'month'
    ? start.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
    : `${format(start)} — ${format(end)} ${end.getFullYear()}` };
}

// Civil dates and times are those of the salon, even when exporting abroad.
export function storyPages(slots, period, now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now);
  const part = type => parts.find(p => p.type === type).value;
  const today = `${part('year')}-${part('month')}-${part('day')}`;
  const time = `${part('hour')}:${part('minute')}`;
  const days = new Map();
  slots.forEach(slot => {
    const date = slot.date.slice(0, 10);
    if (!slot.is_available || date < period.start || date > period.end || date < today || (date === today && slot.start_time <= time)) return;
    if (!days.has(date)) days.set(date, new Set());
    days.get(date).add(slot.start_time.slice(0, 5));
  });
  const rows = [];
  [...days.keys()].sort().forEach(date => {
    const times = [...days.get(date)].sort();
    for (let i = 0; i < times.length; i += 4) rows.push({ date, times: times.slice(i, i + 4), continued: i > 0 });
  });
  const pages = [];
  for (let i = 0; i < rows.length; i += 6) pages.push(rows.slice(i, i + 6));
  return pages.length ? pages : [[]];
}

export function renderStory(canvas, rows, period, page, total) {
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Le navigateur ne permet pas de créer une image.');
  ctx.fillStyle = '#fcfbfa'; ctx.fillRect(0, 0, 1080, 1920);
  ctx.fillStyle = '#eeece7'; ctx.beginPath(); ctx.ellipse(970, 240, 280, 410, -.35, 0, Math.PI * 2); ctx.fill();
  const text = (value, x, y, size, serif = false, color = '#151515') => {
    ctx.fillStyle = color;
    ctx.font = `${size}px ${serif ? 'Fraunces, Georgia, serif' : 'Montserrat, Arial, sans-serif'}`;
    ctx.fillText(value, x, y, 900);
  };
  text('KOREAN LASH LIFT', 90, 210, 25);
  text('by Ali', 90, 294, 64, true);
  text('Un instant', 90, 445, 88, true);
  text('pour vous.', 90, 540, 88, true);
  text('LES DISPONIBILITÉS', 90, 635, 24);
  text(period.title, 90, 694, 32);
  ctx.strokeStyle = '#d8d5cf'; ctx.lineWidth = 2;
  rows.forEach((row, i) => {
    const y = 795 + i * 130;
    const date = new Date(`${row.date}T12:00:00`);
    text(date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }) + (row.continued ? ' · suite' : ''), 90, y, 30, true);
    row.times.forEach((time, j) => text(time.replace(':', 'h'), 90 + j * 225, y + 52, 34));
    ctx.beginPath(); ctx.moveTo(90, y + 79); ctx.lineTo(990, y + 79); ctx.stroke();
  });
  if (!rows.length) {
    text('Aucun créneau disponible', 90, 970, 48, true);
    text('sur cette période.', 90, 1035, 44, true);
    text('Les prochaines dates arrivent bientôt.', 90, 1125, 28);
  }
  ctx.fillStyle = '#151515'; ctx.fillRect(90, 1635, 900, 100);
  text('Réservez sur koreanbyali.fr', 145, 1698, 32, false, '#fcfbfa');
  text('LE NATUREL, SUBLIMÉ.', 90, 1795, 21);
  text(`${page + 1} / ${total}`, 900, 1795, 22);
  return canvas;
}
